module.exports = __webpack_public_path__ + "static/media/PA-Icon-Spielplatz-neg.5ff92849.svg";